export enum HoursPrimaryTabs {
  businessHours = 'businessHours',
  specialtyHours = 'specialtyHours',
}

export enum HoursSecondaryTabs {
  regularHours = 'regularHours',
  holidayHours = 'holidayHours',
  temporarilyClosed = 'temporarilyClosed',
}

export enum HoursSecondaryBusinessTabs {
  permanentlyClosed = 'permanentlyClosed',
}
